import { makeStyles } from '@material-ui/core/styles';
import { Colors } from '../../styles';

const useStyles = makeStyles((theme) => ({
  contentContainer: {
    padding: 12,
  },
  titleLayout: {
    padding: '1.5rem 1rem',
    backgroundColor: Colors.APP_COLOR_HIGHLIGHT(),
    color: 'white',
    borderRadius: '0 !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  tableHeader: {
    background: 'white',
    border: '1px solid rgb(224 224 224)',
    borderBottom: 'none',
    padding: '1rem .5rem',
    color: '#515151',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  header_actions: {
    color: Colors.APP_COLOR_HIGHLIGHT(),
    background: 'white',
    border: '1px solid white',
    marginLeft: '.5rem',
    '&:hover': {
      background: 'white',
    },
  },
}));

export default useStyles;
